var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    focusable: "false",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "StyledIconBase-ea9ulj-0 fHrGFt css-qzygmx-headerRow-BetMultiIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "layers"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24 7.29l8.52 4.63a.51.51 0 00.48 0l8.52-4.63a.44.44 0 00-.05-.81L12.19 3a.5.5 0 00-.38 0L3.29 6.48a.44.44 0 00-.05.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71 10.66l-1.83-.78-6.64 3.61a.51.51 0 01-.48 0L5.12 9.88l-1.83.78a.48.48 0 000 .85l8.52 4.9a.46.46 0 00.48 0l8.52-4.9a.48.48 0 00-.1-.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71 15.1l-1.56-.68-6.91 3.76a.51.51 0 01-.48 0l-6.91-3.76-1.56.68a.49.49 0 000 .87l8.52 5a.51.51 0 00.48 0l8.52-5a.49.49 0 00-.1-.87z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiIcon);
export default __webpack_public_path__ + "static/media/multi-icon.2ee8f854b5f371ba9125c60c58a38026.svg";
export { ForwardRef as ReactComponent };